module.exports = __webpack_public_path__ + "static/media/SF-UI-Display-Bold.0b133318.woff";